import { Button, SizableText, SmartLink, Stack, XStack, YStack, YStackProps } from '@my/ui'
import { SolitoImage } from 'solito/image'

export interface AdStandardProps {
  id: string
  title?: string
  description?: string
  ctaLabel?: string
  href: string
  imageRatio?: 'square' | 'landscape'
  image?: {
    url: string
    alt: string
  }
}

const imageRatioMap = {
  square: 1,
  landscape: 16 / 9,
}

export const AdStandard = ({
  image,
  title,
  description,
  ctaLabel,
  href,
  imageRatio = 'landscape',
  ...props
}: AdStandardProps & YStackProps) => {
  return (
    <YStack gap="$2" pb="$3.5" {...props}>
      <SmartLink
        Component={YStack}
        href={href}
        gap="$3.5"
        hoverStyle={{
          opacity: 0.85,
        }}
        pressStyle={{
          opacity: 0.8,
        }}
        focusStyle={{
          opacity: 0.8,
        }}
      >
        {image && (
          <YStack $gtXs={{ px: '$3.5' }}>
            <Stack
              overflow="hidden"
              aspectRatio={imageRatioMap[imageRatio]}
              width="100%"
              $gtXs={{ br: '$3' }}
            >
              <SolitoImage
                src={image.url}
                alt={image.alt || title || 'Ad image'}
                contentFit="cover"
                fill
                sizes="(max-width: 900px) 100vw, 568px"
              />
            </Stack>
          </YStack>
        )}
        <YStack px="$3.5" gap="$1">
          {title && (
            <SizableText size="$5" fow="600" $gtSm={{ size: '$7.5', fow: '600' }}>
              {title}
            </SizableText>
          )}
          {description && (
            <SizableText size="$1" color="$gray11" $gtSm={{ size: '$3' }}>
              {description}
            </SizableText>
          )}
        </YStack>
      </SmartLink>
      {ctaLabel && (
        <XStack px="$3.5" w="100%">
          <SmartLink Component={Button} href={href} flex={1} theme="black" size="$4">
            {ctaLabel}
          </SmartLink>
        </XStack>
      )}
    </YStack>
  )
}
